import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { currentEditedOverlayGroupSelector } from '@/redux/modal/modal.selector';
import { closeModal } from '@/redux/modal/modal.slice';
import { loginUserSelector } from '@/redux/user/user.selectors';
import { ONE } from '@/constants/common';
import { removeOverlayGroup } from '@/redux/overlayGroup/overlayGroup.thunks';
import { userOverlaysDataSelector } from '@/redux/overlays/overlays.selectors';
import { updateOverlays } from '@/redux/overlays/overlays.thunks';

type RemoveOverlayGroupReturn = {
  handleCancelRemove: () => void;
  handleRemoveAll: () => void;
  handleOrphanChildrenAndRemove: () => Promise<void>;
};

export const useRemoveOverlayGroup = (): RemoveOverlayGroupReturn => {
  const currentEditedOverlayGroup = useAppSelector(currentEditedOverlayGroupSelector);
  const login = useAppSelector(loginUserSelector);
  const dispatch = useAppDispatch();
  const userOverlays = useAppSelector(userOverlaysDataSelector);

  const handleCancelRemove = (): void => {
    dispatch(closeModal());
  };

  const handleRemoveAll = (): void => {
    if (!login || !currentEditedOverlayGroup || !currentEditedOverlayGroup.id) return;
    dispatch(removeOverlayGroup({ overlayGroupId: currentEditedOverlayGroup.id }));
  };

  const handleOrphanChildrenAndRemove = async (): Promise<void> => {
    if (!login || !currentEditedOverlayGroup || !currentEditedOverlayGroup.id) return;

    const overlays = userOverlays.filter(overlay => overlay.group === currentEditedOverlayGroup.id);

    const overlaysToEdit = [];
    for (let i = 0; i < overlays.length; i += ONE) {
      const overlay = { ...overlays[i], group: null };
      overlaysToEdit.push(overlay);
    }
    await dispatch(updateOverlays(overlaysToEdit));

    dispatch(removeOverlayGroup({ overlayGroupId: currentEditedOverlayGroup.id }));
  };

  return {
    handleCancelRemove,
    handleRemoveAll,
    handleOrphanChildrenAndRemove,
  };
};
